import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface FlightFilters {
  dateFrom: string | null;
  dateTo: string | null;
  aircraftType: string;
  visibility: string;
}

interface FlightFilterContextType {
  activeFilters: FlightFilters;
  applyFilters: (filters: FlightFilters) => void;
}

const FlightFilterContext = createContext<FlightFilterContextType | undefined>(undefined);

export const FlightFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeFilters, setActiveFilters] = useState<FlightFilters>(() => {
    const saved = sessionStorage.getItem('flight_filters');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {}
    }
    return {
      dateFrom: null,
      dateTo: null,
      aircraftType: 'all',
      visibility: 'all'
    };
  });

  const applyFilters = (filters: FlightFilters) => {
    setActiveFilters({ ...filters });
    sessionStorage.setItem('flight_filters', JSON.stringify(filters));
  };

  return (
    <FlightFilterContext.Provider value={{ activeFilters, applyFilters }}>
      {children}
    </FlightFilterContext.Provider>
  );
};

export const useFlightFilters = () => {
  const context = useContext(FlightFilterContext);
  if (context === undefined) {
    throw new Error('useFlightFilters must be used within a FlightFilterProvider');
  }
  return context;
};
